import 'css-chunksrc/client/common/notification/styles.scss';export default {
  "notification": "_notification_12q1c_1",
  "messages": "_messages_12q1c_10",
  "message": "_message_12q1c_10",
  "button": "_button_12q1c_20",
  "warning": "_warning_12q1c_31",
  "success": "_success_12q1c_36"
};